import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Reload() {
    const { pathname, state } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const paths = pathname.split('/');
        if (paths.length >= 3) {
            // Forward the navigation state so the page being remounted can tell
            // this was a deliberate reset (sidebar re-click) rather than an
            // ordinary mount, and give the user feedback for it. Nested paths
            // such as /dashboard-services/new are kept whole.
            navigate(`/${paths.slice(2).join('/')}`, { state });
        }
    }, [pathname, state, navigate]);

    return null;
}
